import React, { useEffect, useState } from "react";

import useTranslation from "hooks/useTranslation";
import { FileIcon, ZipFileIcon } from "assets/icons";
import Modal from "components/Modal";
import ModalBody from "components/Modal/ModalBody";
import ModalFooter from "components/Modal/ModalFooter";
import { isValidFileType } from "utils/validation";

const Filepreview = ({
  showFileModal,
  handleSendFileMessage,
  setFileMessage,
  fileMessage,
}) => {
  const [isValidFile, setIsValidFile] = useState(true);
  const { getTranslation } = useTranslation("COMMON");
  const { t } = getTranslation();

  const getSendingFileComponent = (fileInfo) => {
    switch (fileInfo.type) {
      case "audio":
        return (
          <audio controls>
            <source src={fileInfo.fileData} type="audio/ogg" />
            <source src={fileInfo.fileData} type="audio/mpeg" />
          </audio>
        );

      case "image":
        return (
          <div className="file_preview_media_container">
            <img
              alt="img_message"
              src={fileInfo.fileData}
              className="img_message"
            />
          </div>
        );

      case "file": {
        return (
          <div className="file_message_container">
            <img alt="file_icon" className="file_icon" src={FileIcon} />
            <div className="file_description">
              {`${fileMessage.file.name}-${fileMessage.size}`}
            </div>
          </div>
        );
      }

      case "compress":
        return (
          <div className="file_message_container">
            <img alt="file_icon" className="file_icon" src={ZipFileIcon} />
            <div className="file_description">
              {`${fileMessage.file.type}-${fileMessage.size}`}
            </div>
          </div>
        );

      case "video":
        return (
          <div className="file_preview_media_container">
            <video src={fileInfo.fileData} />
          </div>
        );

      default:
        break;
    }
  };

  const handleCloseFileModal = () => {
    setFileMessage(null);
    setIsValidFile(true);
  };

  useEffect(() => {
    if (fileMessage) {
      if (!isValidFileType(fileMessage.file.type)) {
        setIsValidFile(false);
      }
    }
  }, [fileMessage]);

  return (
    fileMessage && (
      <Modal
        setVisibility={handleCloseFileModal}
        visible={showFileModal}
        className="confirmation-modal"
      >
        <ModalBody title={isValidFile ? t("FILE_PREVIEW").ARE_YOU_SURE : ""}>
          {isValidFile ? (
            <div>
              <div>{getSendingFileComponent(fileMessage)}</div>
            </div>
          ) : (
            <div className="conv__body__header_block_user_modal_title">
              {t("FILE_PREVIEW").NOT_SUPPORTING_MSG}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <div className="modal__container__footer__left">
            <button
              onClick={handleCloseFileModal}
              className="btn btn-tertiary"
              id="closeModal"
            >
              {isValidFile ? t("FILE_PREVIEW").CANCEL : t("FILE_PREVIEW").CLOSE}
            </button>
            {isValidFile && (
              <button
                onClick={() => handleSendFileMessage()}
                className="btn btn-primary"
              >
                {t("FILE_PREVIEW").CONFIRM}
              </button>
            )}
          </div>
        </ModalFooter>
      </Modal>
    )
  );
};

export default Filepreview;
